import Link from 'next/link';
import { AnchorHTMLAttributes, MouseEventHandler } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron16.svg';

import { styles } from './PaginationArrow.styles';

interface PaginationArrowProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  direction: 'left' | 'right';
  href: string;
  disabled?: boolean;
  disabledNavigation?: boolean;
}

export function PaginationArrow({
  direction,
  disabled,
  href,
  disabledNavigation,
  onClick,
  ...props
}: PaginationArrowProps) {
  const slots = styles();

  if (disabled) {
    return (
      <span
        aria-disabled="true"
        className={slots.base({ disabled, left: direction === 'left' })}
      >
        <div className={slots.icon()}>
          <ChevronIcon />
        </div>
      </span>
    );
  }

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (disabledNavigation) {
      event.preventDefault();
    }

    onClick?.(event);
  };

  return (
    <Link
      className={slots.base({ disabled, left: direction === 'left' })}
      href={href}
      onClick={handleClick}
      {...props}
    >
      <div className={slots.icon()}>
        <ChevronIcon />
      </div>
    </Link>
  );
}
